var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNu = function SvgIconNu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.74v4.047L7.826 5.74zM6.261 12h3.525L6.261 7.306l-.522 3.652z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.969 12H12v-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.26V0h-.002C5.371.001 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.786L8.474 6.261z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 10.525 7.735 6.26H6.26l5.739 5.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07 1.565q-.694.396-1.327.877h.492l-1.301.946.497 1.53-1.301-.946-.139.101c-.54.614-1.02 1.283-1.427 1.998V12h3.13V4.695H12v-3.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M5.126 2.164q-.194.135-.383.28l-.809.945-.804.585-.14.101q-.441.503-.827 1.052a2.217 2.217 0 0 0 2.963-2.963"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.99 4.074.14-.102 1.301.946-.497-1.53 1.301-.946h-.492A12 12 0 0 0 2.99 4.074M8.295 2.087l.259.798h.838l-.678.492.259.797-.678-.492-.679.492.26-.797-.679-.492h.838zM3.13 7.305l.26.797h.838l-.678.493.258.797L3.13 8.9l-.678.493.26-.797-.679-.493h.838z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconNu;